import { Box, Typography } from '@material-ui/core'
import emotionStyled from '@emotion/styled'
import { colors, Chip, typography } from '@resiliatech/birdsong'
import { styled } from '@mui/material/styles'
import { ConditionalLink } from 'Components/Pages/Academy/Related/AcademyRelatedContentCard/utils'

interface CustomProps {
  titleLength?: number
  completed?: boolean
}

export const AcademyResourceLinkTitleContainer = styled(Box)`
  padding-right: 8px;
`
export const TaskItemRowTitle = emotionStyled(Typography, {
  shouldForwardProp: (prop) => prop !== 'completed',
})<CustomProps>`
  ${typography.baseline.semiBoldSans};
  color: ${colors.interactive.primaryEnabled};
  fontWeight: 600;
  fontSize: '16px';
  textDecoration: completed ? 'line-through' : 'none';
`

export const AcademyResourceLink = styled(ConditionalLink)``

export const ExternalLink = emotionStyled.a`
  ${typography.baseline.semiBoldSans}
  color: ${colors.interactive.primaryEnabled};
  text-decoration: none;
`

export const AcademyResourceType = styled(Chip)`
  font-size: 10px;
  font-weight: 600;
`
export const AcademyResourceTypeContainer = styled(Box)`
  margin-left: 10px;
`
export const AcademyResourceInfoContainer = styled(Box)`
  display: flex;
  flex-direction: row;
`
